export const CreateCardOnFileValidationMessages = {
    cardNumberNotAValidType:
        'Invalid card number. Must be a valid Visa, Mastercard, or American Express number.',
    cardNumberInvalidLuhn:
        'Card number is invalid. Please check the number and try again.',
    cardCodeInvalid: 'Invalid security code for this card.',
    duplicatePaymentInformation:
        'Duplicate payment information detected. Credit card and billing address information must be unique.',
} as const;
